import _ from 'lodash';
import { createSelector } from 'reselect';

import {
  get,
  post,
  put,
  del, } from 'utils/fetch';
import { createListSelector } from 'utils/list';


import { RequestState } from 'constants/constants';

// ======================
// SELECTORS
// ====================== 
export const selectAllGames = (state) => state.models.games
export const selectGamesByIds = createSelector(
  selectAllGames,
  (_, gameIds) => gameIds,
  (games, gameIds) => _.pick(games, gameIds)
);


  


// ======================
// MODEL
// ====================== 
const Game = {
  
  actions: {},

  spec: {
    games: {},
  },

  reducer: (state, type, body, action, json) => {
    if(action.url && action.result !== RequestState.SUCCESS)
      return state;

    if(body && body.games) {
      state = { ...state, 
        games: { 
          ...state.games, 
          ..._.keyBy(body.games, '_id'), 
        }
      };
    }
    return state;
  },

}
export default Game;
